export function applyFilters(list) {
  for (var _len = arguments.length, filterFunctions = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    filterFunctions[_key - 1] = arguments[_key];
  }
  // Apply each filter function successively to the list
  return filterFunctions.reduce(function (filtered, filterFunction) {
    return filtered.filter(filterFunction);
  }, list || []);
}